import { all, AllEffect, ForkEffect, takeEvery, put, call } from 'redux-saga/effects';

import {
  AmlActionTypes,
  getAmlVerificationStatusError,
  getAmlVerificationStatusSuccess,
} from '../actions/amlActions';
import BffApiService from '@/shared/bffApiService';
import { SagaIterator } from 'redux-saga';

export function* getVerificationStatusSaga(): SagaIterator {
  try {
    const response = yield call(BffApiService.getUserAmlVerificationStatus);
    yield put(getAmlVerificationStatusSuccess(response.data.data));
  } catch (error) {
    yield put(getAmlVerificationStatusError());
  }
}

export function* watchAml(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeEvery(AmlActionTypes.GetVerificationStatus, getVerificationStatusSaga)]);
}
